import DataBin from "../../valueObjects/DataBin.js";

class BinValueConverterBase {
    /**
     * Allows to convert all values from single DataBin into other value, usually scalar (flattering)
     * @param {Boolean|undefined} silent - default false, when set to true all exceptions will be 
     * @param {*} defaultValue - when _getBinValue throws an error and silent is set to true, this value will be returned from getBinValue
     */
    constructor(silent, defaultValue) {
        if (typeof(silent) === 'undefined') {
            this.silent = false;
        }
        else if (typeof(silent) !== 'boolean') {
            throw new TypeError('silent must be an boolean or undefined');
        }
        else {
            this.silent = silent;
        }

        this.defaultValue = defaultValue;
    }
    /**
     * Provides value of given DataBin2D instance for HeatMapSeriesProvider
     * @param {DataBin} bin - data bin
     * @param {*} customData - sometimes determining some value for bin may require extra data, this should be  passed by this property and used in inheriting formatter.
     * For example it could be collection of results classified to this bin
     */
    getBinValue(bin, customData) {
        if(!(bin instanceof DataBin)) {
            throw new TypeError('bin must be an instance inheriting from DataBin');
        }

        if (this.silent) {
            try {
                return this._getBinValue(bin, customData);
            } catch (error) {
                return this.defaultValue;
            }
        }

        return this._getBinValue(bin, customData);
    }
	
	_getBinValue(bin, customData) {
		throw new Error('conversion is not implemented');
	}
}

export default BinValueConverterBase;